import { render, staticRenderFns } from "./m-edit-vcard.vue?vue&type=template&id=19fcb36f&scoped=true&"
import script from "./m-edit-vcard.vue?vue&type=script&lang=js&"
export * from "./m-edit-vcard.vue?vue&type=script&lang=js&"
import style0 from "./m-edit-vcard.vue?vue&type=style&index=0&id=19fcb36f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fcb36f",
  null
  
)

export default component.exports